<section class="personal-story-card cmnh-card simple">
  <div class="card-body">
    <div class="personal-story-field">
      <app-cmn-textarea [label]="'SHARE_STORY' | translate" textareaId="personalStory" name="personalStory" rows="5"
        [maxlength]="personalStoryMaxLength" [placeholder]="'PERSONAL_STORY_LABEL' | translate"
        [(ngModel)]="personalStory" showCharacterCount></app-cmn-textarea>
      @if (validationError) {
      <p class="personal-story-error">{{ validationError | translate }}</p>
      }
    </div>
  </div>
</section>